<div class="d-flex align-items-center">
  <p class="page-title me-auto">Add new users to your account to help you manage your business</p>
  <div *ngIf="!isClientPortal">
    <app-client-user-search [currentUsers]="clientUsers" (userChosen)="addExistingUser($event)">
    </app-client-user-search>
  </div>
  <div class="title-bar-btn">
    <button class="btn btn-primary" (click)="openModal()">
      <i class="fas fa-xs fa-plus"></i>&nbsp;Add User
    </button>
  </div>
</div>
<div *ngIf="clientUsers == null || clientUsers.length <= 0">
  <em>No users to display</em>
</div>
<div *ngIf="clientUsers != null && clientUsers.length > 0" class="mt-3">
  <table>
    <thead>
      <tr>
        <th></th>
        <th>Name</th>
        <th>Email</th>
        <th>Status</th>
        <th></th>
        <th>Remove</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let user of clientUsers">
        <td class="text-center pt-2 pb-2"><img src="assets/icons/user-icon.svg" /></td>
        <td>
          <a class="fw-bold" *ngIf="!isCurrentUser(user.UserId)" (click)="openEdit(user)"
            >{{ user.FirstName }} {{ user.LastName }}</a
          >
          <span class="fw-bold" *ngIf="isCurrentUser(user.UserId)"
            >{{ user.FirstName }} {{ user.LastName }} <span class="fw-normal">(Me)</span>
          </span>
        </td>
        <td>{{ user.UserName }}</td>
        <td
          [class.text-danger]="!isUserStatusValid(user)"
          [class.fw-bold]="!isUserStatusValid(user)">
          <span *ngIf="!user.IsLocked">{{ user.RegistrationStatus }}</span>
          <span *ngIf="user.IsLocked">Locked</span>
        </td>
        <td>
          <button
            (click)="resendLink(user)"
            class="btn btn-tertiary ms-3 ml-3"
            *ngIf="
              user.RegistrationStatus === 'Invite Expired' ||
              user.RegistrationStatus === 'Invite Sent'
            ">
            Resend Link
          </button>
          <button
            (click)="unlockUser(user)"
            class="btn btn-tertiary ms-3 ml-3"
            *ngIf="canUserBeUnlocked(user)">
            Unlock User
          </button>
        </td>
        <td>
          <button
            *ngIf="!isCurrentUser(user.UserId)"
            (click)="remove(user)"
            type="button"
            class="btn btn-icon">
            <img src="assets/icons/trash-red.svg" />
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<ng-container *ngIf="showInviteModal">
  <app-client-user-invite-modal
    [clientCode]="clientCode"
    [initialModel]="inviteModel"
    (onCloseDetails)="closeModal($event)">
  </app-client-user-invite-modal>
</ng-container>
